import PropTypes from 'prop-types';
import React from 'react';
import { Grid, makeStyles } from "@material-ui/core";

const ItemShowInfo = (props) => {
    const { title, value, icon, backgroundColor, color } = props;
  
    const useStyles = makeStyles(() => ({
        container: {
            margin: '10px 0',
            width: 250,
            height: 150,
            backgroundColor: '#5bd2ff',
            border:  '1px solid #d2d2d2',
            borderRadius: '10px',
            boxShadow: '-4px 6px 6px #bdbdbd'
        },
        containerIcon: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        info: {
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
            color: '#ffffff',
            '& h3': {
                color: '#ffffff'
            }
        },
        coverIcon: {
            width: 50,
            height: 50,
            backgroundColor: backgroundColor,
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '50%',
            alignItems: 'center',
            color: color
        }
    }))
    const classes = useStyles();


    return (
        <div className={classes.container}>
            <Grid container alignItems='center' style={{ height: '100%', padding: '0 10px' }} justifyContent='space-between' >
                <Grid item className={classes.info}>
                    <div>{title}</div>
                    <h3 >{value}</h3>
                </Grid>
                <Grid item  className={classes.containerIcon}>
                    <div className={classes.coverIcon}>
                        {icon}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}

ItemShowInfo.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
  icon: PropTypes.any,
  color: PropTypes.string,
  backgroundColor: PropTypes.string
};


export default ItemShowInfo;
